import { useStore } from '@nanostores/react'
import { isCartOpen, cartData } from '@stores/cartStore'
import { checkoutData } from '@stores/checkoutStore'
import va from '@vercel/analytics'
import {
    updateCart,
    updateCartDiscountCodes,
    updateCartNote,
    updateCartAttributes,
    updateCheckoutAttributes,
    getCart,
} from '@api/shopify'

import { chord } from '@api/chord.js'

import { addUrlParameter, deepEqual, getCookie } from '@utils/utils'

export const handleQuantityChange = (cartId, id, quantity, type) => {
    if (quantity === -1 || quantity === '-1') {
        return
    }

    if (type === 'increment') {
        quantity = parseInt(quantity) + 1
    } else if (type === 'decrement') {
        quantity = parseInt(quantity) - 1
    }

    let lines = {
        id: id,
        quantity: quantity,
    }

    updateCart(cartId, lines).then((updateCartData) => {
        console.log('updateCartData', updateCartData)
        let cartLines = updateCartData.body.cartLinesUpdate.cart.lines.edges
        let cartCost = updateCartData.body.cartLinesUpdate.cart.cost
        let discountCodes =
            updateCartData.body.cartLinesUpdate.cart.discountCodes

        let cartObj = {
            ...cartData.get(),
            lines: cartLines,
            cost: cartCost,
            discountCodes: discountCodes,
        }
        if (cartLines.length === 0) {
            let discounts = document.getElementsByClassName('remove-discount')
            if (discounts.length > 0) {
                for (let i = 0; i < discounts.length; i++) {
                    discounts[i].click()
                }
            }

            cartObj = {
                ...cartData.get(),
                lines: [],
                cost: {},
                discountCodes: [],
            }
        }

        cartData.set(cartObj)
    })
}

export const handleRemoveDiscount = (
    cartId,
    currentDiscountCodes,
    discountCode
) => {
    if (discountCode) {
        let newDiscountCodes = currentDiscountCodes.filter((discount) => {
            return discount.code !== discountCode
        })

        updateCartDiscountCodes(cartId, newDiscountCodes).then((data) => {
            // // console.log discount remove data', data)
            let cartCost = data.body.cartDiscountCodesUpdate.cart.cost
            let cartLines = data.body.cartDiscountCodesUpdate.cart.lines.edges
            let discountCodes =
                data.body.cartDiscountCodesUpdate.cart.discountCodes

            let cartObj = {
                ...cartData.get(),
                cost: cartCost,
                lines: cartLines,
                discountCodes: discountCodes,
            }

            chord.trackCouponRemoved({
                cartId: cartId.replace('gid://shopify/Cart/', ''),
                couponName: discountCode,
            })

            cartData.set(cartObj)
        })
    }
}

export const handleCheckout = (checkoutUrl) => {
    if (checkoutUrl) {
        let $cartData = cartData.get()

        chord.trackCheckoutStarted({ checkout: $cartData })

        const cartLinesArray = $cartData?.lines.map((line) => {
            let item = line.node

            const str = line.node.merchandise.id
            const n = str.lastIndexOf('/')
            const lineItemId = str.substring(n + 1)

            let product = {
                item_name: item.merchandise.product.title,
                item_id: lineItemId,
                price: item.cost.totalAmount.amount,
                item_category:
                    item.merchandise.product?.options[0]?.values[0] || '',
                item_category2:
                    item.merchandise.product?.options[1]?.values[0] || '',
                item_category3:
                    item.merchandise.product?.options[2]?.values[0] || '',
                item_variant: lineItemId,
                quantity: item.quantity,
            }

            return product
        })

        dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'dl_begin_checkout',
            ecommerce: {
                items: cartLinesArray,
                value: $cartData?.cost?.totalAmount?.amount,
            },
            eventCallback: function () {
                window.location = checkoutUrl
                // const newCheckoutUrl = addUrlParameter(
                //     url.href,
                //     'ref',
                //     'masv',
                //     true
                // )
                // window.location = newCheckoutUrl
            },
        })

        va.track('begin_checkout', {
            cart_id: $cartData?.id,
            cart_items: cartLinesArray,
            cart_total: $cartData?.cost?.totalAmount?.amount,
        })
    }
}

export const manageDiscounts = (cartId, discountCode) => {
    chord.trackCouponEntered({
        cartId: cartId.replace('gid://shopify/Cart/', ''),
        couponName: discountCode,
    })

    return new Promise((resolve) => {
        updateCartDiscountCodes(cartId, discountCode)
            .then((data) => {
                let discountCodes =
                    data.body.cartDiscountCodesUpdate.cart.discountCodes

                if (!discountCodes[0]?.applicable) {
                    chord.trackCouponDenied({
                        cartId: cartId.replace('gid://shopify/Cart/', ''),
                        couponName: discountCode,
                    })

                    resolve(
                        `We're sorry, ${discountCode} is not a valid discount code`
                    )
                } else {
                    let cartCost = data.body.cartDiscountCodesUpdate.cart.cost
                    let cartLines =
                        data.body.cartDiscountCodesUpdate.cart.lines.edges

                    let cartObj = {
                        ...cartData.get(),
                        cost: cartCost,
                        lines: cartLines,
                        discountCodes: discountCodes,
                    }
                    cartData.set(cartObj)

                    chord.trackCouponApplied({
                        cartId: cartId.replace('gid://shopify/Cart/', ''),
                        couponName: discountCode,
                    })

                    resolve('')
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the asynchronous operations
                resolve('An error occurred while applying the discount')
            })
    })
}

export const handleRemoveItem = (cartId, id, hasEmbroidery, variantId) => {
    let $cartData = cartData.get()
    let lines
    let cartLines = $cartData.lines

    // console.log('id in handleRemoveItem', id, cartId, hasEmbroidery)

    let itemRemovedId = variantId?.split('/').pop()

    console.log('itemRemovedId in handleRemoveItem', itemRemovedId)

    if (hasEmbroidery) {
        let matchingEmbroideryOption = cartLines.find((line) => {
            return line.node.merchandise.product.title === 'Embroidery Option'
        })

        let embroideryOptionId = matchingEmbroideryOption?.node?.id
        let matchingEmbroideryOptionId = matchingEmbroideryOption?.node?.attributes[0]?.value
        console.log('matchingEmbroideryOptionId, matchingEmbroideryOption', matchingEmbroideryOptionId, matchingEmbroideryOption)

        if (matchingEmbroideryOptionId.toString() === itemRemovedId.toString()) {

            lines = [
                {
                    id: embroideryOptionId,
                    quantity: 0,
                },
                {
                    id: id,
                    quantity: 0,
                },
            ]
        } else {
            lines = {
                id: id,
                quantity: 0,
            }
        }
    } else {
        lines = {
            id: id,
            quantity: 0,
        }
    }

    if (cartLines && cartLines.length > 0) {
        let items = cartLines
        let itemRemoved = items.filter((item) => {
            console.log('item in gtmItems in cartUtility', item)
            return item.node.id === id
        })

        let gtmItems = itemRemoved.map((item) => {
            let itemId = item.node.merchandise.id
            itemId = itemId.split('/').pop()
            let product = {
                item_name: item?.node?.merchandise?.product?.title,
                item_id: itemId ? itemId : '',
                price: item?.node?.cost?.totalAmount?.amount || '',
                item_category:
                    item.node.merchandise.product?.options[0]?.values[0] || '',
                item_category2:
                    item.node.merchandise.product?.options[1]?.values[0] || '',
                item_category3:
                    item.node.merchandise.product?.options[2]?.values[0] || '',
                item_variant: item?.node?.merchandise?.title,
                quantity: item?.node?.quantity || 1,
            }

            return product
        })

        console.log('itemRemoved in cartUtility, gtmItems, lines', itemRemoved, gtmItems, lines)

        chord.trackProductRemoved({
            cart: $cartData,
            lineItem: itemRemoved?.[0]?.node,
        })

        dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'dl_remove_from_cart',
            ecommerce: {
                items: gtmItems,
            },
        })
    }

    updateCart(cartId, lines).then((updateCartData) => {
        console.log('updateCartData after remove', updateCartData)
        let cartLines = updateCartData.body.cartLinesUpdate.cart.lines.edges
        let cartCost = updateCartData.body.cartLinesUpdate.cart.cost
        let discountCodes =
            updateCartData.body.cartLinesUpdate.cart.discountCodes
        console.log('cartLines in item Removed, cartCost', cartLines, cartCost)

        let cartObj = {
            ...cartData.get(),
            lines: cartLines,
            cost: cartCost,
            discountCodes: discountCodes,
        }

        cartData.set(cartObj)

        // update the cart object if there are no more items in the cart
        if (cartLines.length === 0) {
            let discounts = document.getElementsByClassName('remove-discount')
            if (discounts.length > 0) {
                for (let i = 0; i < discounts.length; i++) {
                    discounts[i].click()
                }
            }

            let cartObj = {
                ...cartData.get(),
                lines: [],
                cost: {},
                discountCodes: [],
            }

            cartData.set(cartObj)
        }
    })
}

export const handleNoteSubmit = (cartId, giftNote) => {
    let encodedGiftNote = encodeURIComponent(giftNote)
    updateCartNote(cartId, giftNote).then((data) => {
        let cartNote = data.body.cartNoteUpdate.cart.note
        let checkoutUrl = cartData.get().checkoutUrl
        let newUrl = ''

        if (checkoutUrl) {
            newUrl = addUrlParameter(
                checkoutUrl,
                'giftNote',
                encodedGiftNote,
                true
            )

            newUrl = addUrlParameter(newUrl, 'giftWrap', 'YES', true)
        }
        let cartObj = {
            ...cartData.get(),
            giftNote: cartNote,
            giftWrap: true,
            checkoutUrl: newUrl,
        }

        cartData.set(cartObj)
    })

    const attributes = [
        {
            key: 'giftWrap',
            value: 'YES',
        },
    ]
}

export const handleCheckoutAttributes = (cartId, giftWrap, giftNote) => {
    let attributes = [
        {
            key: 'gift_wrap',
            value: 'YES',
        },
        {
            key: 'gift_note',
            value: giftNote,
        },
    ]

    const input = {
        customAttributes: attributes,
        note: 'gift_note: ' + giftNote,
    }

    updateCheckoutAttributes(cartId, input).then((data) => {
        console.log('data in updateCheckoutAttributes', data)

        let cartObj = {
            ...cartData.get(),
            checkoutAttributes:
                data?.body?.checkoutAttributesUpdate?.checkout
                    ?.customAttributes || [],
        }

        cartData.set(cartObj)
    })
}

/**
 * Used by Chord. Persist tracking parameters as cart attributes.
 */
export const updateCartTrackingAttributes = async (cartId) => {
    try {
        const input = [
            {
                key: 'segmentId',
                value: window.analytics?.user?.()?.anonymousId?.(),
            },
            {
                key: 'googleClientId',
                value: getCookie('_ga')?.substring(6),
            },
        ]
        return updateCartAttributes(cartId, input)
    } catch (error) {
        console.error('Error updating cart tracking attributes', error)
        return
    }
}
